import { createSelector } from 'reselect';
import { getObjectDefField } from '../../components/Utils/Utils';
import { findNodeByKey } from '../../utils/commonFunctionObjectsReducer';

export const objFormDataSelector = (state) => state?.objects?.objFormData;

export const currObjNbrChildsSelector = (state) =>
  state?.objects?.currObjNbrChilds || -1;

export const perspectivesSelector = createSelector(
  (state) => state.objects.perspectives,
  (data) => {
    if (data) {
      return data
        .map((a) => (a == null ? '' : a))
        .sort((a, b) => (a.module + a.name).localeCompare(b.module + b.name));
    }
    return [];
  }
);

export const isLoadingObjDataSelector = (state) =>
  state?.objects?.isLoadingObjData;

export const isLoadingPerspectivesSelector = (state) =>
  state?.objects?.isLoadingPerspectives;

export const objectsDefListSelector = createSelector(
  (state) => state.objects.objectsDefList,
  (data) => data
);

const selectDataColumns = (state) => state.objects.dataColumns;
const selectObjectsDefList = (state) => state.objects.objectsDefList;

export const selectFilteredDataColumns = createSelector(
  [selectDataColumns, selectObjectsDefList],
  (cols, objectsDefList) => {
    if (!cols) return undefined;
    return cols.map((level) =>
      level.filter((elem) =>
        getObjectDefField(objectsDefList, elem.to, elem.data)
      )
    );
  }
);

export const selectorNodeValue = (key, field) =>
  createSelector(
    (state) => findNodeByKey(state.objects.nodes, key),
    (node) => node?.[field]
  );
